export enum UserRole {
    ViewOnly = 1,
    LimitedUser = 2,
    FullUser = 3,
    Admin = 4,
};